"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DialogUtil_1 = require("../../../Components/Window/Dialog/DialogUtil");
const WindowManager_1 = require("../../../Components/Window/WindowManager");
const Druid_1 = require("../../../Druid");
class DialogUI {
    constructor(options) {
        var _a, _b, _c, _d, _e;
        this.initialized = false;
        this.overlay = document.createElement((_b = (_a = Druid_1.default.configuration().dialog) === null || _a === void 0 ? void 0 : _a.overlayTemplate) !== null && _b !== void 0 ? _b : DialogUI.OVERLAY_TPL);
        this.frame = document.createElement((_e = (_d = (_c = Druid_1.default.configuration().dialog) === null || _c === void 0 ? void 0 : _c.frameTemplate) === null || _d === void 0 ? void 0 : _d.call(_c, options === null || options === void 0 ? void 0 : options.classes)) !== null && _e !== void 0 ? _e : DialogUI.FRAME_TPL(options === null || options === void 0 ? void 0 : options.classes));
        this.header = this.frame.queryRole('header');
        this.headerTitle = this.header.queryRole('title');
        this.closeButton = this.header.queryRole('close');
        this.content = this.frame.queryRole('content');
        this.footer = this.frame.queryRole('footer');
    }
    /**
     * Set the title of the dialog
     */
    setTitle(title) {
        this.headerTitle.innerHTML = title !== null && title !== void 0 ? title : '';
        return this;
    }
    show() {
        this.overlay.style.display = 'block';
        this.frame.style.display = 'block';
        return this;
    }
    hide() {
        this.overlay.style.display = 'none';
        this.frame.style.display = 'none';
        return this;
    }
    destroy() {
        this.overlay.remove();
        this.frame.remove();
        // broadcast to page an element and its children have been disposed
        Druid_1.default.dispose(this.frame);
        return this;
    }
    /**
     * UI initializer
     */
    setupUI(options) {
        var _a;
        // set title if any
        this.headerTitle.innerHTML = (_a = options.title) !== null && _a !== void 0 ? _a : '';
        if (options.closeButtonText !== undefined) {
            this.closeButton.innerText = options.closeButtonText;
        }
        if (options.closable === false) {
            this.closeButton.remove();
        }
        if (this.initialized) {
            return this;
        }
        this.initialized = true;
        this.overlay.style.zIndex = (++WindowManager_1.default.zIndex).toString();
        this.frame.style.zIndex = (++WindowManager_1.default.zIndex).toString();
        // and append to document
        document.body.appendChild(this.overlay);
        this.overlay.appendChild(this.frame);
        if (options.draggable !== false) {
            DialogUtil_1.default.makeDraggable(this.frame, this.overlay, this.header);
        }
        return this;
    }
    /**
     * Set the dialog icon
     */
    setupIcon(options) {
        // remember original class name
        if (this.headerTitleClassName === undefined) {
            this.headerTitleClassName = this.headerTitle.className;
        }
        let iconClasses = '';
        if (options.icon && options.icon.length > 0) {
            iconClasses += Druid_1.default.configuration().icon.className + ' ' + options.icon;
            if (options.iconTheme && options.iconTheme.length > 0) {
                iconClasses += ' ' + options.iconTheme;
            }
        }
        this.headerTitle.className = this.headerTitleClassName + ' ' + iconClasses;
        return this;
    }
}
DialogUI.OVERLAY_TPL = '<div class="dr-dialog-overlay">';
DialogUI.FRAME_TPL = (classes) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return `
            <div class="${(_a = classes === null || classes === void 0 ? void 0 : classes.frame) !== null && _a !== void 0 ? _a : 'dr-dialog-frame'}">
                <div class="${(_b = classes === null || classes === void 0 ? void 0 : classes.header) !== null && _b !== void 0 ? _b : 'dr-header'}" data-role="header">
                    <span class="${(_c = classes === null || classes === void 0 ? void 0 : classes.title) !== null && _c !== void 0 ? _c : 'dr-title'}" data-role="title"></span>
                    <span class="${(_d = classes === null || classes === void 0 ? void 0 : classes.close) !== null && _d !== void 0 ? _d : 'dr-close'}" data-role="close"></span>
                </div>
                <div class="${(_e = classes === null || classes === void 0 ? void 0 : classes.wrapper) !== null && _e !== void 0 ? _e : 'dr-wrapper'}" data-role="wrapper">
                    <div class="${(_f = classes === null || classes === void 0 ? void 0 : classes.content) !== null && _f !== void 0 ? _f : 'dr-content'}" data-role="content"></div>
                    <div class="${(_g = classes === null || classes === void 0 ? void 0 : classes.footer) !== null && _g !== void 0 ? _g : 'dr-footer'}" data-role="footer"></div>
                </div>
            </div>`;
};
exports.default = DialogUI;
//# sourceMappingURL=DialogUI.js.map